export default function checkRight(props?: any) {
  return (
    <svg {...props} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1767" width="13" height="13">
      <path d="M0 0m128 0l768 0q128 0 128 128l0 768q0 128-128 128l-768 0q-128 0-128-128l0-768q0-128 128-128Z" fill="#358643" p-id="1768"></path>
      <path d="M461.952 563.392l-99.52-98.56a70.912 70.912 0 0 0-99.456 0 69.12 69.12 0 0 0 0 98.56l99.584 98.56 49.792 49.344c27.52 27.264 72 27.264 99.52 0l298.624-295.68a69.12 69.12 0 0 0 0-98.56 70.784 70.784 0 0 0-99.584 0l-248.96 246.336z" fill="#FFFFFF" p-id="1769"></path>
    </svg>
  );
}